import script from "./ClientInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./ClientInfoModal.vue?vue&type=style&index=0&id=161ff0fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161ff0fc"]])

export default __exports__